/*
 * Add failed event on closing popup window
 * https://github.com/nvh95/react-linkedin-login-oauth2/blob/v1.0.8/src/LinkedIn.js
 * with
 * https://github.com/nvh95/react-linkedin-login-oauth2/pull/3
 */
import { Component } from 'react';



const getPopupPositionProperties = ({ width = 600, height = 600 }) => {
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    return `left=${left},top=${top},width=${width},height=${height}`;
};

export class LinkedIn extends Component {
    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage, false);
        if (this.popupInterval) window.clearInterval(this.popupInterval);
        if (this.popup && !this.popup.closed) this.popup.close();
    }

    getUrl = () => {
        const {
            redirectUri,
            clientId,
            state,
            scope,
            supportIE,
            redirectPath
        } = this.props;
        const scopeParam = `&scope=${supportIE ? scope : encodeURI(scope)}`;
        const linkedInAuthenLink = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}${scopeParam}&state=${state}`;
        if (supportIE) {
            const redirectLink = `${
                window.location.origin
            }${redirectPath}?linkedin_redirect_url=${encodeURIComponent(
                linkedInAuthenLink
            )}`;
            return redirectLink;
        }
        return linkedInAuthenLink;
    };

    receiveMessage = (event) => {
        const { state } = this.props;
        if (event.origin === window.location.origin) {
            if (event.data.errorMessage && event.data.from === 'Linked In') {
                // Prevent CSRF attack by testing state
                if (event.data.state !== state) {
                    this.popup && this.popup.close();
                    return;
                }
                this.props.onFailure(event.data);
                this.popup && this.popup.close();
            } else if (event.data.code && event.data.from === 'Linked In') {
                // Prevent CSRF attack by testing state
                if (event.data.state !== state) {
                    this.popup && this.popup.close();
                    return;
                }
                this.props.onSuccess({ code: event.data.code });
                this.popup && this.popup.close();
            }
        }
        window.clearInterval(this.popupInterval);
    };

    handleConnectLinkedInClick = (e) => {
        if (e) {
            e.preventDefault();
        }
        this.props.onClick && this.props.onClick();
        this.popup = window.open(
            this.getUrl(),
            '_blank',
            getPopupPositionProperties({ width: 600, height: 600 })
        );
        this.popupInterval = window.setInterval(this.handlePopupClose, 4000);
        window.removeEventListener('message', this.receiveMessage, false);
        window.addEventListener('message', this.receiveMessage, false);
    };

    handlePopupClose = () => {
        if (this.popup && this.popup.closed) {
            this.props.onFailure({
                error: 'window closed',
                errorMessage: 'Login failed. Please try again.',
                from: 'Linked In'
            });
            window.clearInterval(this.popupInterval);
            this.popupInterval = undefined;
        }
    };

    render() {
        const { className, disabled, children, renderElement } = this.props;
        if (renderElement) {
            return renderElement({
                onClick: this.handleConnectLinkedInClick,
                disabled
            });
        }
        return (
            <button
                type="button"
                onClick={this.handleConnectLinkedInClick}
                className={className}
                disabled={disabled}
            >
                {children}
            </button>
        );
    }
}

LinkedIn.defaultProps = {
    className: 'btn-linkedin',
    disabled: false,
    children: (
        <img
            src={require('react-linkedin-login-oauth2/assets/linkedin.png')}
            alt="Log in with Linked In"
            style={{ maxWidth: '180px' }}
        />
    ),
    state: 'fdsf78fyds7fm',
    supportIE: false,
    redirectPath: '/linkedin',
    scope: 'r_emailaddress'
};
export default LinkedIn;
